import { InputGroup } from '@blueprintjs/core';
import { AddButton } from 'es/app/components/buttons/Buttons';
import withSuspense from 'es/core/hocs/withSuspense';
import { useI18n } from 'es/core/hooks/useI18n';
import React, { useState } from 'react';
import { RefreshIconButton } from '../buttons/IconButton';
import styles from './GridToolbar.module.css';
import cn from 'classnames';
import { useTheme } from 'es/app/theme';
import { BootstrapStyles } from 'es/app/visuals/styles/BootstrapStyles';
import { useDebouncedCallback } from 'use-debounce';

interface IToolbarProps {
    total: number;
    displayedTotal: number;
    onFilterTextChange: (value: string) => void;
    onAdd?: () => void;
    onRefresh?: () => void;
    gridActions?: React.ReactElement;
}

const GridToolbar = (props: IToolbarProps) => {
    const { displayedTotal, onFilterTextChange, total, gridActions, onAdd, onRefresh } = props;
    const { l10n } = useI18n('app/components', 'dataGrid');
    const handleAddButtonClick = () => onAdd?.();
    const handleRefreshButtonClick = () => onRefresh?.();
    const { themeName } = useTheme();
    const [text, setText] = useState('');
    const debounceHandleFilterTextChange = useDebouncedCallback(onFilterTextChange, 400);

    return (
        <div
            className={cn(BootstrapStyles['p-2'], styles.gridToolbar, {
                [styles.gridToolbarLight ?? '']: themeName === 'light',
                [styles.gridToolbarDark ?? '']: themeName === 'dark',
            })}
        >
            <div className={styles.gridToolbarSearch}>
                <InputGroup
                    value={text}
                    placeholder={l10n('search')}
                    onChange={e => {
                        setText(e.target.value);
                        debounceHandleFilterTextChange(e.target.value);
                    }}
                />

                {total > 0 && (
                    <span>
                        {displayedTotal}/{total}
                    </span>
                )}
            </div>

            <div>
                {onAdd && !gridActions && <AddButton className={styles.addButton} onClick={handleAddButtonClick} />}
                {onRefresh && !gridActions && <RefreshIconButton onClick={handleRefreshButtonClick} />}
                {gridActions}
            </div>
        </div>
    );
};

export default withSuspense(GridToolbar);
